export const titleTypes = [
  { value: "Dr.", key: "Dr." },
  { value: "Mr.", key: "Mr." },
  { value: "Mrs.", key: "Mrs." },
];
